import { render, staticRenderFns } from "./ProductListJumbotron.vue?vue&type=template&id=3a846d66"
import script from "./ProductListJumbotron.vue?vue&type=script&lang=js"
export * from "./ProductListJumbotron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports